<template>
  <InformationContractChildren :mapType="'global'"/>
</template>

<script>
import InformationContractChildren from '@/components/InformationContractChildren/index.vue'

export default {
  components: {
    InformationContractChildren
  },
  data() {
    return {

    }
  },
  methods: {

  },
  mounted() {},
}
</script>

<style lang="scss" scoped>

</style>
